export const filterDataByRole = ({ roleId, data }) => {
  return data.find((dt) => dt.role === +roleId);
};
